import { useState, useEffect } from "react";
import { getFormStepStatus } from "../services/FormStepStatusService";
import { StepStatus } from "../interfaces/StepStatus";

export function useStepStatus(client: any, filterID: number, formStepsStatusEndpoint: string) {
    const [stepStatus, setStepStatus] = useState<StepStatus | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchStatus() {
            setLoading(true);
            const status = await getFormStepStatus(client, filterID, formStepsStatusEndpoint);
            setStepStatus(status);
            setLoading(false);
        }
        if (client && filterID) {
            fetchStatus();
        }
    }, [client, filterID]);

    return { stepStatus, loading };
}
